module.exports = __webpack_public_path__ + "static/MLB-Logotype-white-53f39ea2a1ea6f0fed099a14f3d6552b.svg";